//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import versionNumber from '@/components/versionNumber';
import config from '@/config';
const ENVIRONMENT = [
  { label: '开发', value: 'Dev' },
  { label: '测试', value: 'Test' },
  { label: '预发布', value: 'Pre' },
  { label: '正式', value: 'Prod' },
];
const envs = {
  development: 'Dev',
  test: 'Test',
  preview: 'Pre',
  production: 'Prod',
};
export default {
  components: {
    versionNumber,
  },
  data() {
    return {
      loading: false,
      search: {
        env: '',
        tenant_id: '',
        appid: 0,
        page: 1,
        page_size: 10,
      },
      creatFrom: {
        appid: '',
        tag: '',
        description: '',
      },
      total: 0,
      list: [],
      appOption: [],
      creatVisible: false,
      creatRules: {
        appid: {
          required: true,
          message: '请选择产品',
          trigger: 'blur',
        },
        tag: {
          required: true,
          message: '请填写完整版本号',
          trigger: 'blur',
        },
      },
    };
  },
  computed: {
    ENVIRONMENT() {
      return ENVIRONMENT;
    },
    app() {
      const obj = {};
      this.appOption.forEach((item) => {
        obj[item.id] = item;
      });
      return obj;
    },
  },
  created() {
    this.getAppOption();
    this.search.env = envs[config.env || 'production'] || 'Prod';
    this.getList();
  },
  methods: {
    getAppOption() {
      const cb = (data) => {
        this.appOption = data.data;
      };
      this.$request({
        url: this.$api.getAppList,
        data: {
          page: 1,
          page_size: 9999,
        },
        cb,
      });
    },
    async getList() {
      this.loading = true;
      try {
        this.$request({
          url: this.$api.getVersionTagList,
          data: {
            env: this.search.env,
            tenant_id: this.search.tenant_id, // 租户id，不为空则查找对应租户id的版本
            limit: this.search.page_size,
            offset: this.search.page_size * (this.search.page - 1),
            app_id: Number(this.search.appid),
          },
          cb: ({ list, count }) => {
            this.list = list;
            this.total = Number(count);
            this.loading = false;
          },
        });
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    onSubmit() {
      this.search.page_size = 10;
      this.search.page = 1;
      this.getList();
    },
    async setTag() {
      this.$refs.creatFrom.validate(async (valid) => {
        if (valid) {
          try {
            this.$request({
              url: this.$api.setTag,
              data: { ...this.creatFrom },
              cb: () => {
                this.creatFrom = {
                  tag: '',
                  description: '',
                };
                this.$message({
                  message: '设置成功',
                  type: 'success',
                });
                this.creatVisible = false;
                this.search.page = 1;
                this.getList();
              },
            });
          } catch (err) {
            console.log(err);
            this.creatVisible = true;
          }
        } else {
          return false;
        }
      });
    },
    itemDetail({ tag, app_id }) {
      this.$router.push({
        name: 'version-manage-detail',
        query: {
          env: this.search.env,
          appid: app_id,
          tag,
        },
      });
    },
    itemDiff({ tag, app_id }) {
      this.$router.push({
        name: 'version-manage-diff',
        query: {
          env: this.search.env,
          appid: app_id,
          tag,
        },
      });
    },
    async del(row) {
      try {
        await this.$confirm(`确定删除版本${row.tag}?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        await this.$request({
          url: this.$api.deleteAuthTag,
          data: {
            env: this.search.env,
            tag: row.tag,
            appid: row.app_id,
          },
        });
        this.$message({
          message: '删除成功',
          type: 'success',
        });
        this.onSubmit();
      } catch (err) {
        console.log(err);
      }
    },
    handleSizeChange(value) {
      this.search.page_size = value;
      this.search.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.getList();
    },
  },
};
